import { useContext } from 'react';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { ContentContext } from '@/data/context/content';

export const useProductDetailsContext = () => {
	const context = useContext(ContentContext) as ReturnType<typeof useProductDetails> & {
		disclaimerSize?: string;
	};
	return context;
};
